import DatePicker from 'react-datepicker';
import { Button, Icon } from 'semantic-ui-react';
import styled from '@emotion/styled';
import { format } from 'date-fns';
import { useState } from 'react';

interface MonthPickerItem {
  date: Date;
  onChange: (date: Date | null) => void;
}

export const MonthPicker = ({ date, onChange }: MonthPickerItem) => {
  const [isOpen, setIsOpen] = useState(false);

  const renderMonthContent = (_m: number, shortMonth: string) => {
    return <span>{shortMonth}</span>;
  };

  const shiftMonth = (delta: number) => {
    const nextDate = new Date(date.getFullYear(), date.getMonth() + delta, 1);
    onChange(nextDate);
  };

  const handleChange = (newDate: Date | null) => {
    setIsOpen(!isOpen);
    if (newDate !== null) {
      onChange(new Date(newDate.getFullYear(), newDate.getMonth(), 1));
    }
  };

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <StyledDiv>
      <LeftButton basic compact onClick={() => shiftMonth(-1)}>
        <StyledIcon color="blue" name="caret left" />
      </LeftButton>
      <CalendarContainer>
        <CalendarButton basic compact onClick={handleClick}>
          <CalendarButtonContent>
            <CalendarSpan>{format(date, 'MMM yyyy')}</CalendarSpan>{' '}
            <CalendarIcon color="black" name="caret down" />
          </CalendarButtonContent>
        </CalendarButton>
        {isOpen && (
          <DatePickerContainer>
            <DatePicker
              selected={date}
              renderMonthContent={renderMonthContent}
              showMonthYearPicker
              dateFormat="MMM yyyy"
              onChange={(date) => handleChange(date)}
              onClickOutside={() => setIsOpen(false)}
              inline
            />
          </DatePickerContainer>
        )}
      </CalendarContainer>
      <RightButton basic compact onClick={() => shiftMonth(1)}>
        <StyledIcon color="blue" name="caret right" />
      </RightButton>
    </StyledDiv>
  );
};

const CalendarContainer = styled.div`
  position: relative;
`;
const DatePickerContainer = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
`;

const CalendarButton = styled(Button)`
  position: relative;
  padding-right: 10px !important;
  padding-left: 10px !important;
  white-space: nowrap;
  width: 110px;
`;

const CalendarButtonContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CalendarSpan = styled.span`
  font-weight: bold;
`;

const CalendarIcon = styled(Icon)`
  padding-left: 10px !important;
`;

const StyledIcon = styled(Icon)`
  margin: 0px !important;
`;

const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  text-align: center;
  align-items: center;
`;

const LeftButton = styled(Button)`
  margin-right: 15px !important;
  padding: 8px !important;
`;

const RightButton = styled(Button)`
  margin-left: 15px !important;
  padding: 8px !important;
`;
